import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Log } from "ng2-logger";
import { RequestType } from "@models/enums/request-type.enum";
import { TableColumnComponent } from "@components/custom-table/components/column/table-column.component";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { ToolRequestHistory } from '@app/shared/models/tool-request-history.model';
import { ToolRequestStatus } from "@app/tool/model/enums/tool-request-status.enum";
import { ToolReturnHistory } from "@models/tool-return-history.model";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-tool-return-history-table',
    templateUrl: './tool-return-history-table.component.html',
    styleUrls: ['./tool-return-history-table.component.scss']
})
export class ToolReturnHistoryTableComponent implements OnInit {
    _logger = Log.create(ToolReturnHistoryTableComponent.name);

    @ViewChild('date', {static: true}) dateColumn: TableColumnComponent;

    @Input() toolReturnHistory: ToolReturnHistory[] = [];
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() headerBackgroundColor: string;
    @Input() hasTitle = false;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() rowClick = new EventEmitter<any>();

    filterStatusList = [];
    filterTypeList = [];

    constructor(private translateService: TranslateService) {
        this.filterStatusList = this.buildStatusFilterColumnKeys();
        this.translateService.onLangChange.subscribe((event) => {
            this.filterStatusList = this.buildStatusFilterColumnKeys();
            this._logger.info('onLangChange:: Language keys', this.filterStatusList);
        });
        this.filterTypeList = this.buildRequestTypeFilterColumnKeys();
        this.translateService.onLangChange.subscribe((event) => {
            this.filterTypeList = this.buildRequestTypeFilterColumnKeys();
            this._logger.info('onLangChange:: Language keys', this.filterTypeList);
        });
    }

    ngOnInit() {
        this.dateColumn.sort = {
            active: true,
            direction: 'desc'
        };
    }

    onPageChange(tableConfig: TableConfig) {
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this.filterChange.emit(tableConfig);
    }

    buildStatusFilterColumnKeys() {
        return [
            {name: this.translateService.instant("generic.statuses.all"), value: 'All'},
            {
                name: this.translateService.instant("generic.statuses.new"),
                value: ToolRequestStatus.NEW
            },
            {
                name: this.translateService.instant("generic.statuses.inTransport"),
                value: ToolRequestStatus.IN_TRANSPORT
            },
            {
                name: this.translateService.instant("generic.statuses.approved"),
                value: ToolRequestStatus.APPROVED
            },
            {
                name: this.translateService.instant("generic.statuses.rejected"),
                value: ToolRequestStatus.REJECTED
            },
            {
                name: this.translateService.instant("generic.statuses.pending"),
                value: ToolRequestStatus.WAITING_FOR_APPROVAL
            },
            {
                name: this.translateService.instant("generic.statuses.closed"),
                value: ToolRequestStatus.CLOSED
            },
            {
                name: this.translateService.instant("generic.statuses.canceled"),
                value: ToolRequestStatus.CANCELED
            },
            {
                name: this.translateService.instant("generic.statuses.delivered"),
                value: ToolRequestStatus.DELIVERED
            },
            {
                name: this.translateService.instant("generic.statuses.waitingForProcessing"),
                value: ToolRequestStatus.WAITING_FOR_PROCESSING
            }
        ];
    }

    buildRequestTypeFilterColumnKeys() {
        return [
            {name: this.translateService.instant("generic.statuses.all"), value: 'All'},
            {
                name: this.translateService.instant("generic.types.line"),
                value: RequestType.LINE
            },
            {
                name: this.translateService.instant("generic.types.ticket"),
                value: RequestType.TICKET
            }
        ];
    }

    onTableRowClick(request: ToolRequestHistory) {
        this.rowClick.emit(request);
    }

}
